<template>
  <div class="exportBox">
    <el-button type="primary" @click="onSubmit" >导出数据</el-button>
  </div>
</template>

<script>
export default {
  name: "exportBtn",
  props: {},
  data() {
    return {};
  },
  created() {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
.exportBox {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
</style>
